import { LoadingOutlined } from "@ant-design/icons";

const Loading = () => {
	return <div className='loading-po' ><LoadingOutlined /></div>;
};
export default Loading;